import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceDetail } from "../../features/workspaces/workspace-detail";

export const Route = createFileRoute("/_authed/$org/$project/workspaces/$name/$tab")({
  validateSearch: (s: Record<string, unknown>): { connect?: string; focus?: string } => ({
    ...(s.connect === "ssh" ? { connect: "ssh" } : {}),
    ...(s.focus === "spec.maxCostUSD" ? { focus: "spec.maxCostUSD" } : {}),
  }),
  component: WorkspacePage,
});

function WorkspacePage() {
  const { org, project, name, tab } = Route.useParams();
  const { connect } = Route.useSearch();
  return <WorkspaceDetail key={JSON.stringify([org, project, name])} scope={{ org, project }} name={name} tab={tab} {...(connect ? { connect } : {})} />;
}
